import {
  SignInPage,
  type SignInProviderConfig,
} from '@backstage/core-components';
import type { SignInPageProps } from '@backstage/plugin-app-react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: '100vh',
    position: 'relative',
  },
  brand: {
    position: 'absolute',
    top: theme.spacing(2),
    right: theme.spacing(4),
    zIndex: 101,
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(1),
    pointerEvents: 'none',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  mark: {
    width: 32,
    height: 44,
    objectFit: 'contain',
  },
  wordmark: {
    width: 56,
    height: 32,
    objectFit: 'contain',
  },
}));

type ThinkSignInPageProps = SignInPageProps & {
  provider: SignInProviderConfig;
};

export const ThinkSignInPage = ({
  provider,
  ...props
}: ThinkSignInPageProps) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.brand} aria-label="THiNK Engineering">
        <img
          className={classes.mark}
          src="/brand/think-mark-purple.png"
          alt=""
          aria-hidden="true"
        />
        <img
          className={classes.wordmark}
          src="/brand/think-wordmark-white.png"
          alt="THiNK"
        />
      </div>
      <SignInPage {...props} provider={provider} />
    </div>
  );
};
